export const PaginationPage = ({ pagination, onPageChange }) => {
  if (!pagination.last_page || pagination.last_page <= 1) return null;

  const { current_page, last_page } = pagination;
  const pageNumbers = [];

  // always show first page
  if (current_page > 3) {
    pageNumbers.push(1);
    if (current_page > 4) pageNumbers.push("...");
  }

  // show 2 pages before and after current page
  for (let i = current_page - 2; i <= current_page + 2; i++) {
    if (i > 0 && i <= last_page) {
      pageNumbers.push(i);
    }
  }

  // always show last page
  if (current_page < last_page - 2) {
    if (current_page < last_page - 3) pageNumbers.push("...");
    pageNumbers.push(last_page);
  }

  return (
    <nav aria-label="Installment pagination" className="mt-4">
      <ul className="pagination justify-content-center">

        {/* Previous Button */}
        <li className={`page-item ${current_page === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(current_page - 1)}
          >
            &laquo; Previous
          </button>
        </li>

        {/* Page Numbers */}
        {pageNumbers.map((page, index) =>
          page === "..." ? (
            <li key={index} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          ) : (
            <li
              key={index}
              className={`page-item ${page === current_page ? "active" : ""}`}
            >
              <button className="page-link" onClick={() => onPageChange(page)}>
                {page}
              </button>
            </li>
          )
        )}

        {/* Next Button */}
        <li className={`page-item ${current_page === last_page ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(current_page + 1)}
          >
            Next &raquo;
          </button>
        </li>

      </ul>
    </nav>
  );
};
